<template>
  <div>
    <div class="drop-area item_upload" v-loading="loading" @dragover.prevent @dragenter.prevent @dragleave="dragging = false"
      @drop.prevent="handleDrop" @click="openFileInput" :class="{ 'drag-over': dragging }">
      <input ref="fileInput" @change="handleFileChange" type="file" id="file" accept="image/*" multiple="false"
        class="file_input">
      <img :src="image || require('@/assets/img/icon_upload.5fb30875.svg')" alt="">
      <div class="upload_tips">
        <div class="main_tip">{{ $t('loan.dropHere') }}, {{ $t('loan.or') }}&nbsp; <span>{{ $t('loan.Browse') }}</span></div>
        <div class="sub_tip">{{ $t('loan.supports') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Compressor from 'compressorjs';
import { upload } from '@/api/upload';
export default {
  data() {
    return {
      dragging: false,
      image: '',
      loading: false,
      file:null
    }
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  watch: {
    // 监听来自父组件的 value 变化，更新 image
    value(newValue) {
      this.image=newValue;
    },
  },
  methods: {
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      // //console.log(event);
      // 限制图片大小
      // const isLt2M=event.target.files[0].size / 1024 / 1024 < 50;
      // if (!isLt2M) {
      //   this.$toast.error(this.$t('tuPianDaXiaoBuNengChaoGuo_5m'));
      //   this.$refs.fileInput.value = '';
      //   return false;
      // }
      const file=event.target.files[0];
      this.handleFile(file);
    },
    handleDrop(event) {
      this.dragging=false;
      const file=event.dataTransfer.files[0];
      this.handleFile(file);
    },
    
    handleFile(file) {
      const reader = new FileReader();    
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            canvas.toBlob((blob) => {
            const jpgImageData = new File([blob], file.name + '.jpg', { type: 'image/jpeg', lastModified: Date.now() });
            this.file = jpgImageData
            this.uploadImage();    
            }, 'image/jpeg', 0.5); // 0.9为JPG质量，可以根据需要调整
        };
        img.onerror = () => {
          this.$toast.error('Please check that your picture format is correct');
        }
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);

    },

    async uploadImage() {
      this.loading=true;
      try {
        // 使用FormData构建文件上传
        const formData = new FormData();
        formData.append('file', this.file);
        
        // 发送POST请求到后端
        const response = await upload(formData).then(res => {
          // //console.log(res);
          if (res.code === 200) {
            // 如果是http转换成https
            let url = res.url
            if (url.startsWith('http://')) {
              url = url.replace('http://', 'https://');
            }
            // //console.log(url);
            this.$emit('input', url);
          } else if (res.code === 401) {
            // Only redirect if we're not already on the login page
            if (this.$route.path !== '/pass/login') {
              this.$router.push('/pass/login').catch(err => {
                // Handle navigation errors gracefully
                if (err.name !== 'NavigationDuplicated') {
                  console.error('Navigation error:', err);
                }
              });
            }
          } else {
            this.$toast.error(this.$t(res.msg));
          }
          });
      } catch (error) {
        // console.error('Error uploading image:', error);
        this.$toast.error({
          message: JSON.stringify(error)
        });
        this.$refs.fileInput.value = '';
        this.image = '';
      } finally {
        this.loading=false;
      }
    },
    dataURLtoFile(dataURL, filename) {
      const arr = dataURL.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
  },
}
</script>
<style lang="scss" scoped>
.item_upload {
  padding: .24rem 0;
  border: .01rem dashed #000;
  border-radius: .2rem;
  text-align: center
}

.item_upload .file_input {
  display: none
}

.item_upload .upload_tips {
  color: #000
}

.item_upload .upload_tips .main_tip {
  font-size: .16rem
}

.item_upload .upload_tips .main_tip span {
  cursor: pointer;
  color: #4d4fff
}

.item_upload .upload_tips .sub_tip {
  margin-top: .1rem;
  color: rgba(0, 0, 0, .5);
  font-size: .14rem
}

.item_upload_resilt {
  width: .72rem;
  height: .72rem
}
.item_upload img{
  width: .72rem;
  height: .72rem
}

</style>